import React from 'react';
import { VolumeTimeframe } from '../types/StockData';

interface VolumeTimeframeSelectorProps {
  selectedTimeframe: VolumeTimeframe;
  onTimeframeChange: (timeframe: VolumeTimeframe) => void;
}

const timeframeOptions: { value: VolumeTimeframe; label: string; days: number }[] = [
  { value: '1W', label: '1 Week', days: 7 },
  { value: '1M', label: '1 Month', days: 31 },
  { value: '3M', label: '3 Months', days: 93 },
  { value: '6M', label: '6 Months', days: 186 },
];

export const VolumeTimeframeSelector: React.FC<VolumeTimeframeSelectorProps> = ({
  selectedTimeframe,
  onTimeframeChange,
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
      <h4 className="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wide">
        Time Period
      </h4>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
        {timeframeOptions.map((option) => (
          <button
            key={option.value}
            onClick={() => onTimeframeChange(option.value)}
            className={`
              px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200
              ${selectedTimeframe === option.value
                ? 'bg-blue-600 text-white shadow-md'
                : 'bg-gray-50 text-gray-700 hover:bg-gray-100 border border-gray-200'
              }
            `}
          >
            <div className="text-center">
              <div className="font-semibold">{option.label}</div>
              <div className="text-xs opacity-75">{option.days} days</div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
